export default {"src":"/_next/static/media/mail.8dcdc086.svg","height":126,"width":133,"blurWidth":0,"blurHeight":0};